/**
 * getExampleText
 *  获取自定义字段 Example 的打印文本
 *  @param {object} field - 当前字段的数据
 *  @return {string} return the printText
 **/
const getExampleText = (field) => {
	const { fieldValue = '{}' } = field;
	const { text = '' } = JSON.parse(fieldValue);
	return text;
};

export default getExampleText;
